var ccErrorNo = 0;
var ccErrors = new Array()

ccErrors[0] = "Type de carte Inconnu";
ccErrors[1] = "Aucun num&eacute;ro de carte n'a &eacute;t&eacute; saisi.\nMerci de renseigner votre num&eacute;ro de carte bancaire.";
ccErrors[2] = "Le format de votre num&eacute;ro de carte est invalide";
ccErrors[3] = "Le num&eacute;ro de votre carte est invalide";
ccErrors[4] = "Le num&eacute;ro de votre carte n'a pas la bonne longueur";
ccErrors[5] = "Le Code de v&eacute;rification ou le cryptogramme visuel de votre carte est invalide";
ccErrors[6] = "Aucun nom n'a &eacute;t&eacute; saisi.\nMerci de renseigner votre nom";
ccErrors[7] = "La date d'expiration de votre carte est incorrecte";

try {
    var alias_verif = document.getElementById('do_alias').value;
} catch (e) {}

function changeCarte(nom, num, mois, annee, id) {

    var checkbox_checked = true;

    if (typeof(nom) == 'undefined') {

        id = 0;
        nom = '';
        num = '';
        var ladate = new Date();
        mois = '01';
        annee = ladate.getFullYear();
        checkbox_checked = false;

        $("#name_without_card").focus();

    }

    $("#alias_id").val(id);
    $("#name_without_card").val(nom);
    $("#numero_without_card").val(num);
    $("#date_exp_mois_without_card").val(mois);
    $("#date_exp_mois_without_card").prev().html(mois);
    $("#date_exp_annee_without_card").val(annee);
    $("#date_exp_annee_without_card").prev().html(annee);

    $("#bloc_other_alias").slideUp();
    is_deplie = false;
    document.getElementById('do_alias').checked = checkbox_checked;

}

var is_deplie = false;

function deleteFlexAlias(evt) {

    var alias = this.form;
    var alias_id = alias.alias_id.value.trim();

    var parent = $(alias.parentElement);

    evt.preventDefault();

    $.ajax({
        url: path_relative_root + 'ajax_delete_alias.php',
        method: 'GET',
        data: { id: alias_id },
        success: function(res) {

            if (res == 1) {

                parent.animate({ height: 0, opacity: 0 }, 350, function() {

                    parent.remove();
                });
            }
        }
    });

    return false;
}

$(function() {

    "use strict";

    $("form.alias").on("input", "input[name=cvc]", function() {

        var val = this.value.trim();

        $("button.use", this.form).prop("disabled", (val.length < 3));
    });

    $("form.alias").on("click", "button.use", function() {

        if (!$(this).is("disabled")) {

            $(this).addClass("loading");
        }
    });
});